"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.messages = void 0;
exports.messages = {
    required: 'Required',
    invalidURL: 'Please enter a valid URL',
    disallowSpaces: 'Entering only spaces is not a valid input'
};
//# sourceMappingURL=messages.js.map